import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IMenu, IMenuItem } from "../../interfaces/imenu";
import { IUser } from "../../interfaces/ilogin";
import { Router, RouterModule } from "@angular/router";
import { IAppStore } from "../../iappstore";
import { Store } from "@ngrx/store";
import { TooltipModule } from "ngx-bootstrap/tooltip";

@Component({
    selector: "nav-menu",
    standalone: true,
    imports: [CommonModule, RouterModule, TooltipModule],
    templateUrl: "./navmenu.component.html",
})
export class NavMenuComponent {
    menu: IMenu;
    constructor(store: Store<IAppStore>, private router: Router) {
        this.menu = {
            menuItems: new Array<IMenuItem>()
        } as IMenu;

        let user: IUser = null;

        store.select(e => e.user)
            .subscribe(e => user = e);

        store.select(e => e.user.selectedBusinessFunction)
            .subscribe((selectedBusinessFunction) => {
                this.menu = {
                    menuItems: new Array<IMenuItem>()
                } as IMenu;
                if (user || (selectedBusinessFunction || selectedBusinessFunction.id)) {
                    this.router.config.forEach(item => {
                        // build up menu items based on navigation data
                        if (item.data && item.data['navigation'] && item.data['security']) {
                            const roles: string[] = item.data['security'].roles as string[];
                            const rolesFound: string[] = roles.filter((r: string) => user.roles.indexOf(r) > -1);
                            if (rolesFound.length > 0) {
                                const navItem: IMenuItem = item.data['navigation'] as IMenuItem;
                                navItem.routerLink = `/${item.path}`;
                                this.menu.menuItems.push(navItem);
                            }
                        }
                    });

                    // sort menu items
                    this.menu.menuItems = this.menu.menuItems.sort((a: IMenuItem, b: IMenuItem) => {
                        if (a.sortOrder < b.sortOrder) {
                            return -1;
                        } else if (a.sortOrder > b.sortOrder) {
                            return 1;
                        }
                        return 0;
                    });
                }
            });
    }

    /**
     * gets called when a menu item is clicked
     * @param menuItem the clicked menu item
     */
    onNavMenuClick(menuItem: IMenuItem):void {
        this.router.navigate([`/${menuItem.routerLink}`]);
    }
}
